import { ChevronDownIcon, Loader2Icon, PlusIcon, RefreshCcwIcon, Settings2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { MembersToolbarButton } from '@/components/common/members-management';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface CompanyMembersHeaderActionsProps {
  createPath: string;
  isRefreshing: boolean;
  onRefresh: () => void;
  onReset: () => void;
}

export function CompanyMembersHeaderActions({
  createPath,
  isRefreshing,
  onRefresh,
  onReset,
}: CompanyMembersHeaderActionsProps) {
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <MembersToolbarButton>
            Options
            <ChevronDownIcon data-icon="inline-end" />
          </MembersToolbarButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-64">
          <DropdownMenuGroup>
            <DropdownMenuLabel>Options de page</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem disabled={isRefreshing} onClick={onRefresh}>
              {isRefreshing ? <Loader2Icon className="animate-spin" /> : <RefreshCcwIcon />}
              Actualiser la liste
            </DropdownMenuItem>
            <DropdownMenuItem onClick={onReset}>
              <Settings2Icon />
              Réinitialiser recherche et filtres
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
      <Button
        asChild
        variant="outline"
        className="h-12 border-black bg-black px-6 text-[15px] font-medium text-white shadow-none transition-colors hover:border-black/85 hover:bg-black/85 hover:text-white dark:border-border dark:bg-muted dark:text-foreground dark:hover:border-foreground/20 dark:hover:bg-muted/80 dark:hover:text-foreground"
      >
        <Link data-testid="company-member-create-link" to={createPath}>
          <PlusIcon data-icon="inline-start" />
          Créer un membre
        </Link>
      </Button>
    </>
  );
}
